import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../utils/cn';
import { STAGE_META, stagesForTrack } from '../../utils/stages';
import type { StageId, Track } from '../../types/domain';
interface StageStepperProps {
  track: Track;
  currentStage: StageId;
  selectedStage: StageId;
  daysInStage: number;
  onSelect: (stage: StageId) => void;
}
export function StageStepper({
  track,
  currentStage,
  selectedStage,
  daysInStage,
  onSelect
}: StageStepperProps) {
  const stages = stagesForTrack(track);
  const currentIndex = stages.indexOf(currentStage);
  return <div className="rounded-sm border border-border bg-card p-3" data-id="element-1012" data-mp="2davjz2vrh6jo">
      <ol className="flex flex-col gap-2 md:flex-row md:items-stretch" data-id="element-1013" data-mp="2dc6ox60y0kcd">
        {stages.map((stage, index) => {
        const meta = STAGE_META[stage];
        const isComplete = index < currentIndex;
        const isCurrent = index === currentIndex;
        const isSelected = stage === selectedStage;
        return <li key={stage} className="flex-1" data-id="element-1014" data-mp="3gmfbiqrgvekx" data-mpi={index}>
              <button type="button" onClick={() => onSelect(stage)} aria-current={isCurrent ? 'step' : undefined} className={cn('group flex h-full w-full flex-col rounded-sm border px-3 py-2.5 text-left transition-colors', isComplete && 'border-uae-green/25 bg-uae-green/[0.06]', isCurrent && 'border-uae-leaf bg-uae-leaf text-white', !isComplete && !isCurrent && 'border-border bg-card hover:bg-muted', isSelected && !isCurrent && 'ring-2 ring-uae-gold ring-offset-1')} data-id="element-1015" data-mp="3glnfjetyjeu4">
                <span className={cn('flex items-center gap-1.5 text-[10px] font-semibold uppercase tracking-[0.1em]', isCurrent ? 'text-white/75' : 'text-muted-foreground')} data-id="element-1016" data-mp="3bn2gvjuct37s">
                  {isComplete && <Check className="h-3 w-3 text-uae-leaf" aria-hidden="true" data-id="element-1017" data-mp="2b6bw0v3136ag" />}
                  Stage {index + 1}
                  {isCurrent && <span className="text-white/90" data-id="element-1018" data-mp="275jms1u5p1e6">· current</span>}
                </span>
                <span className={cn('mt-1 text-[13px] font-semibold tracking-tight', isCurrent ? 'text-white' : 'text-foreground')} data-id="element-1019" data-mp="2kwoemhra8pdy">
                  {meta.label}
                </span>
                <span className={cn('mt-1 text-[11px] leading-snug', isCurrent ? 'text-white/75' : 'text-muted-foreground')} data-id="element-1020" data-mp="1o65pb9x7x8ix">
                  {isCurrent ? `${daysInStage} days in stage` : meta.blurb}
                </span>
              </button>
            </li>;
      })}
      </ol>
      <div className="mt-2 flex gap-1" aria-hidden="true" data-id="element-1021" data-mp="3dmn76n4or4nd">
        {stages.map((stage, index) => <span key={stage} className={cn('h-1 flex-1 rounded-full', index < currentIndex && 'bg-uae-green', index === currentIndex && 'bg-uae-leaf', index > currentIndex && 'bg-border')} data-id="element-1022" data-mp="udybkxlarpkw" data-mpi={index} />)}
      </div>
    </div>;
}